Array::remove = (v) -> $.grep @,(e)->e!=v
